<template>
  <div v-if="items.length" class="graph-legend" :class="{ 'graph-legend--dark': dark }">
    <p class="graph-legend__title">类型筛选</p>
    <button
      v-for="item in items"
      :key="item.value"
      type="button"
      class="graph-legend__item"
      :class="{ 'graph-legend__item--active': value === item.value }"
      :disabled="!item.count"
      @click="handleClick(item)"
    >
      <span class="graph-legend__dot" :style="{ background: item.color }" />
      <span class="graph-legend__label">{{ item.label }}</span>
      <span class="graph-legend__count">{{ item.count }}</span>
    </button>
  </div>
</template>

<script>
import { GRAPH_CATEGORY_OPTIONS } from '@/utils/tupuGraphConfig'

export default {
  name: 'GraphCategoryLegend',
  props: {
    nodes: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    items() {
      const counts = this.nodes.reduce((map, node) => {
        const key = node && node.category
        if (key) {
          map[key] = (map[key] || 0) + 1
        }
        return map
      }, {})
      return GRAPH_CATEGORY_OPTIONS
        .map((item) => ({ ...item, count: counts[item.value] || 0 }))
        .filter((item) => item.count > 0)
    }
  },
  methods: {
    handleClick(item) {
      this.$emit('input', this.value === item.value ? '' : item.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.graph-legend {
  position: absolute;
  left: rem(12);
  bottom: rem(12);
  z-index: 5;
  min-width: rem(132);
  padding: rem(10) rem(12);
  background: rgba($color-cream, 0.94);
  border: 1px solid rgba($color-brown-dark, 0.1);
  border-radius: 6px;
  box-shadow: 0 6px 20px rgba($color-brown-dark, 0.12);

  &--dark {
    background: rgba($color-brown-dark, 0.88);
    border-color: rgba($color-white, 0.12);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.28);

    .graph-legend__title,
    .graph-legend__label {
      color: $color-cream;
    }

    .graph-legend__count {
      color: rgba($color-cream, 0.7);
    }

    .graph-legend__item {
      &:hover:not(:disabled) {
        background: rgba($color-white, 0.08);
      }

      &--active {
        background: rgba($color-white, 0.14);
      }
    }
  }

  &__title {
    margin-bottom: rem(8);
    font-size: rem(11);
    letter-spacing: 1px;
    color: $color-text-light;
  }

  &__item {
    display: flex;
    align-items: center;
    width: 100%;
    gap: rem(8);
    padding: rem(4) rem(6);
    border-radius: 4px;
    text-align: left;
    color: $color-brown-dark;
    transition: background 0.15s;

    &:hover:not(:disabled) {
      background: rgba($color-brown-dark, 0.06);
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }

    &--active {
      background: rgba($color-brown-dark, 0.1);
    }
  }

  &__dot {
    width: rem(10);
    height: rem(10);
    border-radius: 50%;
    flex-shrink: 0;
  }

  &__label {
    flex: 1;
    font-size: rem(12);
  }

  &__count {
    font-size: rem(11);
    color: $color-text-light;
  }
}
</style>
